import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { MediaData } from '~admin/model/media-data';
import { mapMediaData } from '~admin/model/media-data.mapper';
import { MediaCreationRequest } from '~client/model/admin/media-creation-request';
import { MediaResponse } from '~client/model/media-response';
import { rxTask, ThreeArgTask } from '~common/helper/mobx-tasks';

export type MediaUploadTask = ThreeArgTask<FormData, string, MediaCreationRequest, MediaData>;

/* Allows to upload media files like images and videos */
export const performMediaUpload = (formData: FormData): Observable<MediaResponse> =>
  apiClient.mediaAdminController.uploadMedia$(formData);

export const mediaUploadFactory = (): MediaUploadTask =>
  rxTask<FormData, MediaData>((formData) => performMediaUpload(formData).pipe(map(mapMediaData)));



// WEBPACK FOOTER //
// ./interactor/media/perform-upload-media.ts